import { onMounted, onUnmounted, ref } from 'vue';

export function useWindowWidth() {
  const smallPixel = 767;
  const extraSmallPixel = 424;
  const pageWidth = ref(window.innerWidth + 'px');
  const isSmallPixel = ref(window.innerWidth <= smallPixel);
  const isExtraSmallPixel = ref(window.innerWidth <= extraSmallPixel);

  const updateWidth = () => {
    pageWidth.value = window.innerWidth + 'px';
    isSmallPixel.value = window.innerWidth <= smallPixel;
    isExtraSmallPixel.value = window.innerWidth <= extraSmallPixel;
  };

  onMounted(() => {
    window.addEventListener('resize', updateWidth);
  });

  onUnmounted(() => {
    window.removeEventListener('resize', updateWidth);
  });

  return { pageWidth, isSmallPixel, isExtraSmallPixel };
}
